function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M12.35 18.93h8.326a.938.938 0 0 0 0-1.875H12.35a.938.938 0 0 0 0 1.875m3.39-10.08h1.547a.938.938 0 0 0 0-1.876H15.74a.938.938 0 0 0 0 1.876m9.681-1.876h-1.957a.938.938 0 0 0 0 1.876h1.02V24.79H8.542V8.85h1.02a.938.938 0 0 0 0-1.876H7.603c-.517 0-.937.505-.937 1.023v17.732c0 .518.42.938.937.938h17.817c.518 0 .938-.42.938-.938V7.997c0-.518-.42-1.023-.938-1.023M12.35 14.711h8.327a.938.938 0 0 0 0-1.876H12.35a.938.938 0 0 0 0 1.876m7.915-4.035c.647 0 1.172-.525 1.172-1.172V6.505a1.172 1.172 0 0 0-2.344 0v2.999c0 .647.524 1.172 1.172 1.172M11.59 9.504V6.505a1.172 1.172 0 0 1 2.344 0v2.999a1.172 1.172 0 0 1-2.344 0",
  id: "a"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#b)",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32 0v32H0V0z"
})));

function SvgIconBOs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBOs);
export default __webpack_public_path__ + "static/media/icon-b-os.8c049454.svg";
export { ForwardRef as ReactComponent };